import React from "react";
import styled from "styled-components";

export default styled.label`
    padding: 15px;
    padding-top: 42px;
    padding-bottom: 40px;
    border: 1px solid #CECEDC;
    overflow: auto;
    display: block;
    cursor: pointer;
    margin-bottom: 20px;
    position: relative;
    display: ${(props) => (!props.hidden ? 'block' : 'none')};
    width: calc(50% - 20px);
    float: left;
    margin: 0 10px;
`;